import axios from "axios";
import * as vars from "./vars";

export function findCollegeMentors (findCollegeMentorsRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/matching/FindCollegeMentors`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: findCollegeMentorsRequest
    })
}

export function getDisplayMentors (getDisplayMentorsRequest) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/untrusted/matching/GetDisplayMentors`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: getDisplayMentorsRequest
    })
}


export function  fetchStudentProfile (username, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/matching/FetchStudentProfile',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            username
        }
    })
}

export function  fetchMentorProfile (username, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/matching/FetchMentorProfile',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            username
        }
    })
}

// attribute = [“skills” | “clubs” | “accomplishments” | “job_positions” | “experiences”]
export function getMentorAttribute (mentorUsername, attribute, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/matching/GetMentorAttribute',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            mentorUsername: mentorUsername,
            attribute: attribute
        }
    })
}